export default "__VITE_ASSET__DVmUWPT___"